<template>
    <div class="page-warpper home">
        <div class="part-panel" data-index='intro'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg">
                <p class='part-txt'>满怀音乐梦想却无处安放？是时候亮出你的实力！</p>
                <p class='part-txt'>美的空调#爱在无风时#原创音乐大赛进行中，</p>
                <p class='part-txt'>只要你对音乐足够热爱，<span class='key-txt'>20万梦想基金</span>等你来挑战！</p>
                <p class='part-txt'>优秀选手还有机会和导师同台合唱并由导师点评指导作品！</p>
                <p class='part-txt'>这个夏天，让我们一起为原创发声，为音乐尖叫！</p>
            </div>
        </div>
        <div class="part-panel" data-index='sign'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg">
                <img src="../assets/images/index/sign-step.png" alt="">
                <!-- <ul  class='part-txt'>
                    <li><span class='num'>1</span>参赛作品形式为音频，要求以“爱在无风时”为主题，选手通过歌词或旋律表现对主题的理解认知，<span class='key-txt'>歌词能结合“无风感”“无风清凉”“无风舒适”等与美的无风感空调结合的关键词发挥最佳。</span></li>
                    <li><span class='num'>2</span><span class='key-txt'>作品（词、曲）必须原创</span>，曲风不限，流行、说唱、摇滚、民谣、R&B、Jazz、古风等皆可。</li>
                    <li><span class='num'>3</span>选手可自行选择是否上传参赛作品相关视频，形式不限，MV、才艺秀、小剧场等皆可。比赛报名结束后，<span class='key-txt'>所有视频播放量排名前5者可额外获得价值129元的酷狗M1耳机和巅峰争霸赛门票2张</span>。</li>
                    <li><span class='num'>4</span>参赛者每人最多可提交3个作品，作品版权必须为参赛者本人所有。</li>
                    <li><span class='num'>5</span>原创歌曲参赛作品要求为【演唱曲】，<span class='key-txt'>参赛作品命名格式：【爱在无风时】+歌曲名。</span>发布作品后，带话题#爱在无风时#发布微博并@原创音乐基地 @美的空调官方微博。</li>
                    <li><span class='num'>6</span>为避免比赛中产生不必要的质疑和纠纷，请所有参赛选手保留比赛歌曲的干声。</li>
                </ul> -->
                <ul  class='part-txt'>
                    <li><span class='num'>1</span>参赛作品形式为音频，要求以“爱在无风时”为主题，选手通过歌词或旋律表现对主题的理解认知，歌词能结合“无风感”“无风清凉”“无风舒适”等与美的无风感空调结合的关键词发挥最佳。</li>
                    <li><span class='num'>2</span>作品（词、曲）必须原创，曲风不限，流行、说唱、摇滚、民谣、R&B、Jazz、古风等皆可。</li>
                    <li><span class='num'>3</span>选手可自行选择是否上传参赛作品相关视频，形式不限，MV、才艺秀、小剧场等皆可。比赛报名结束后，<span class='key-txt'>所有视频播放量排名前5者可额外获得价值129元的酷狗M1耳机和巅峰争霸赛门票2张</span>。</li>
                    <li><span class='num'>4</span>参赛者每人最多可提交3个作品，作品版权必须为参赛者本人所有。</li>
                    <li><span class='num'>5</span>原创歌曲参赛作品要求为【演唱曲】，参赛作品命名格式：【爱在无风时】+歌曲名。发布作品后，带话题#爱在无风时#发布微博并@原创音乐基地 @美的空调官方微博。</li>
                    <li><span class='num'>6</span>为避免比赛中产生不必要的质疑和纠纷，请所有参赛选手保留比赛歌曲的干声。</li>
                </ul>
                <img class='img-gap' src="../assets/images/index/sign-t.png" alt="">
                <signTab ></signTab>
            </div>
        </div>
        <div class="part-panel" data-index='songTop15'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg">
                <workTop  ></workTop> 
            </div>
        </div>
        <div class="part-panel" data-index='mvTop15'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg">
                <workTop :selfIdx=1 ></workTop> 
            </div>
        </div>
        <div class="part-panel" v-if="bannerList.length>1">
            <swiper :options="swiperOption" ref="mySwiper">
                <!-- slides -->
                <template  v-for="(slide,index) in bannerList">
                    <swiper-slide v-if="index%2 == 0">
                        <img  v-bind:src="slide.img" v-bind:alt="slide.title">
                    </swiper-slide>
                </template>
                
                <!-- <swiper-slide>I'm Slide 1</swiper-slide>
                <swiper-slide>I'm Slide 2</swiper-slide>
                <swiper-slide>I'm Slide 3</swiper-slide> -->
                <!-- Optional controls -->
                <div class="swiper-pagination"  slot="pagination"></div>
                <!-- <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div> -->
                <!-- <div class="swiper-scrollbar"   slot="scrollbar"></div> -->
            </swiper>
        </div>
        <div class="part-panel" data-index='activityRim'>
            <div  class="part-warpper" data-index='weibo'>
                <h1 class="part-title"></h1>
                <div class="part-body">
                    <iframe src="http://widget.weibo.com/topics/topic_vote_base.php?border=0&amp;footbar=1&amp;width=560&amp;height=339&amp;refer=1&amp;filter=0&amp;language=zh_cn&amp;version=base&amp;dup=0&amp;antispam=0&amp;isOutTopicSearch=0&amp;top_mblog=z8ClGsZa8&amp;isshowright=0&amp;tag=%25E7%2588%25B1%25E5%259C%25A8%25E6%2597%25A0%25E9%25A3%258E%25E6%2597%25B6&amp;og=http%3A%2F%2F5sing.kugou.com%2Fsubject%2Fmdkt2018%2Findex&amp;app_src=4zBKQR&amp;r=1531299723100" width="560" height="930" frameborder="0" scrolling="no" marginheight="0"></iframe>
                </div>
            </div>
            <div  class="part-warpper" data-index='sponsor'>
                <div data-index='1'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item md" href="javascript:void(0);" ></a>
                        <a class="part-item kugou" href="javascript:void(0);" ></a>
                        <a class="part-item sing" href="javascript:void(0);" ></a>
                    </div>
                </div>
                <div data-index='2'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item " href="javascript:void(0);" ></a>
                    </div>
                </div>
                <div data-index='3'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item za" href="javascript:void(0);" ></a>
                        <a class="part-item yd" href="javascript:void(0);" ></a>
                        <a class="part-item grt" href="javascript:void(0);" ></a>
                        <a class="part-item sy" href="javascript:void(0);" ></a>
                        <p class='txt'>(排序不分先后)</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import signTab from '@/components/sign-tab'
import workTop from '@/components/work-top'
export default {
    name: 'indexHome',
    data () {
        return {
            msg: 'Welcome to Your Vue.js App',
            bannerList:[],
            swiperOption: {
                loop:true,
                // NotNextTick is a component's own property, and if notNextTick is set to true, the component will not instantiate the swiper through NextTick, which means you can get the swiper object the first time (if you need to use the get swiper object to do what Things, then this property must be true)
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                allowTouchMove: false,
                // swiper configs 所有的配置同swiper官方api配置
                //autoplay:true,
                //autoplayDisableOnInteraction : false,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                // direction : 'vertical',
                //effect:"coverflow",
                //grabCursor : true,  //分页器点击小圆点跳转到对应页面不能与设置抓手grabCursor : true同时设置
                setWrapperSize :true,
                // autoHeight: true,
                // paginationType:"bullets",
                //分页器设置         
                pagination: {
                    el: '.swiper-pagination',
                    clickable :true
                },
                //左右点击
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev',
                // },
                // scrollbar:'.swiper-scrollbar',
                //mousewheelControl : true,
                //observeParents:true,
                // if you need use plugins in the swiper, you can config in here like this
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                // debugger: true,
                // swiper callbacks
                // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
                // onTransitionStart(swiper){
                //   console.log(swiper)
                // },
                // more Swiper configs and callbacks...
                // ...
            }
        }
    },
    components: {
        signTab,
        workTop,
    },
    created: function() {
        let _this = this;
        this.$server.getBannerList({aid: _this.$winConfig.activityId}).then(function(res){
            res = res.data;
            if(res.data){

                _this.bannerList = res.data;
            }
        })
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "../assets/sass/cmn.scss";
.img-gap{
    margin:10px 0;
}
.swiper-container{
    height: 180px;
    .swiper-slide{
        img{
            width: 100%;
        }
    }
}
.part-panel[data-index="intro"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-intro.png'));
    }
    .part-body{
        font-size: 20px;
        text-align: center;
    }
}
.part-panel[data-index="sign"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-sign.png'));
    }
}
.part-panel[data-index="songTop15"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-songtop.png'));
    }
}
.part-panel[data-index="mvTop15"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-mvtop.png'));
    }
}
.part-panel[data-index="activityRim"]{
    //width: 1030px;
     //width: 1130px;
    vertical-align: top;
    font-size: 0;
    .part-warpper{
        display: inline-block;
        font-size: 0;
    }
    .part-warpper[data-index="weibo"]{
        width: 560px;
        .part-title{
            margin-bottom: 20px;
            background-image: url(componentsImgPath('index/title-w.png'));
            background-position: top center;
        }
        .part-body{
            overflow: auto;
            width: 100%;
            height: 620px;
            overflow-x: hidden;
            background: #fff;
        }
    }
    .part-warpper[data-index="sponsor"]{
        //width: 570px;
        width: 450px;
        vertical-align: top;
        div[data-index="1"]{
            .part-item {
                margin: 10px 0 0 0;
            }
            .md{
                width: 150px;
            }
            .kugou{
                width: 400px;
                //background-image: url(componentsImgPath('index/sponsor-1.1.png'));
                //background-position: top center;
            }
            .sing{
                width: 127px;

            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/index-home.vue